import { css } from "@emotion/react";

import { breakpoints } from "../../../../constants/mediaqueries";

// Mirrors Helper/BottomBar/bottomBar.styles.ts, pinned to the TOP of the
// viewport instead of the bottom (D6).
//
// `topOffset` is DefaultLayout's measured offline-banner height, taken the same
// way its own fixed header takes it (`fixedHeaderStyle(visible, offlineBarHeight)`)
// and the same way the content column offsets its margin-top. Without it this
// bar would be the one fixed element that ignores the banner, and going offline
// would paint the warning straight over it. It is 0 whenever IsOfflineBar
// renders nothing, which is the normal case.
//
// Stacking, verified against DefaultLayout rather than assumed: the app header
// is itself `position: fixed; z-index: 1000` with a hide-on-scroll transform
// (`fixedHeaderStyle`, DefaultLayout.tsx:19-33) — NOT in-flow. At an equal z-index the later
// element in DOM order wins, and the header wrapper is rendered before the
// content column this bar lives in, so the bar paints over the header. Going
// higher is not free: the offline banner sits at 1001 and must stay on top of
// both. Reactstrap modals are 1050+, so SignalDetailModal still covers the bar.
//
// That header is fixed with a transform, but it is a SIBLING of the content
// column, never an ancestor of this bar — nothing in the chain from <body> down
// to here carries a transform, which is what `position: fixed` needs.
// The card is INSET from the viewport edge rather than flush against it, so it
// reads as a floating card the way BottomBar's does. BottomBar gets that inset
// from a wrapper class rather than from its styles — `py-md-4` on the div around
// its card (Helper/BottomBar/index.tsx) — which is why copying only this
// stylesheet produced a bar glued to the top edge. The values match what
// BottomBar ends up with: 1.5rem from md up (`py-md-4`), and 1rem below it,
// where BottomBar uses `bottom: 1rem` instead. Kept here rather than as a
// wrapper class so the offset and the inset stay in one place.
//
// `pointer-events` is the price of the inset. This wrapper is a fixed, mostly
// transparent strip; padding makes it cover a band of the app header ABOVE the
// visible card, and it already covered a 1rem gutter each side. Without this,
// that transparent area silently eats clicks meant for the header underneath.
// The card takes events back. Reactstrap portals both modals to <body>, so they
// are unaffected either way.
export const activeSignalBarStyles = (topOffset: number) => css`
    z-index: 1000;
    position: fixed;
    top: ${topOffset}px;
    left: 50%;
    max-width: 2800px;
    width: 100%;
    padding-inline: 1rem;
    padding-block: 1rem;
    transform: translateX(-50%);
    pointer-events: none;

    @media (min-width: ${breakpoints[1]}px) {
        padding-block: 1.5rem;
    }

    & > * {
        pointer-events: auto;
    }
`;
